var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"product-nav"},_vm._l((_vm.navList),function(item){return _c('li',{key:item.value,staticClass:"shou",class:{
      'product-active': _vm.active == item.id,
    },on:{"click":function($event){return _vm.$emit('change', item.id)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }